import {TestBed} from '@angular/core/testing';
import {DummyComponent} from 'test-helpers/dummy.component';

export function hasOwnProperty(obj, property) {
    return obj && Object.prototype.hasOwnProperty.call(obj, property);
}

export function sleep(time: number = 0): Promise<void> {
    return new Promise(res => setTimeout(res, time));
}

export function whenStable(): Promise<void> {
    const fixture = TestBed.createComponent(DummyComponent);
    return fixture.whenStable();
}

export function getCallStack() {
    const error = new Error();
    const stack = error.stack.split('\n');
    stack.splice(1, 1);
    return stack.join('\n');
}
